import { Directive, inject, input, OnInit } from '@angular/core';
// Импорт FormPickerComponent должен быть полным для исключения циклических зависимостей
import { FormPickerComponent } from '@core/components/form-picker/form-picker.component';
import { filter, map, switchMap } from 'rxjs';
import { RequestsApiService } from '@core/services/request/requests-api.service';
import { toObservable } from '@angular/core/rxjs-interop';

@Directive({
  selector: 'x-form-picker[xAttachSubdivisions]',
  standalone: true,
})
export class AttachSubdivisionsDirective implements OnInit {
  private readonly requestAPIService = inject(RequestsApiService);
  private readonly component = inject(FormPickerComponent);
  readonly $contractorId = input.required<number | null>({
    alias: 'contractorId',
  });
  readonly contractorId$ = toObservable(this.$contractorId);
  ngOnInit() {
    this.component.items$ = this.contractorId$.pipe(
      filter(Boolean),
      switchMap(contractorId =>
        this.requestAPIService.getContractorSubdivisions$(contractorId),
      ),
      map(result =>
        result.map(({ counterpartyId, ...rest }) => ({
          ...rest,
          counterpartyId: counterpartyId.id,
        })),
      ),
    );
  }
}
